<template>
  <div
    class="flex flex-col lg:flex-row lg:gap-4"
    :class="{'gap-2': totalPrice}"
  >
    <CustomButton
      :text="primaryButtonText"
      data-testid="sidebarPrimaryButton"
      type="primary"
      :disabled="disabled"
      class="order-1 lg:order-2"
      @click="$emit('primaryButtonClick')"
    />
    <CustomButton
      v-if="secondaryButtonText"
      :text="secondaryButtonText"
      :thin-text="true"
      data-testid="sidebarSecondaryButton"
      type="link-dark"
      class="order-2 lg:order-1"
      @click="$emit('secondaryButtonClick')"
    />
    <div
      v-if="totalPrice"
      class="cart-price flex justify-end items-end gap-4 lg:gap-2 w-full"
    >
      <div>
        {{ priceLabel }}
      </div>
      <div
        class="text-xl font-bold"
        data-testid="sidebarTotalPrice"
      >
        {{ $n(totalPrice, 'currency') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'CartSidebarButtons',

  props: {
    primaryButtonText: {
      type: String,
      required: true,
    },
    secondaryButtonText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    totalPrice: {
      type: Number,
      default: null,
    },
    priceLabel: {
      type: String,
      default: '',
    },
  },
  emits: ['primaryButtonClick', 'secondaryButtonClick'],
});

</script>
